import { bool, func, number, object, oneOf, string } from 'prop-types'
import { Component } from 'react'
import {
  AreaUploader,
  kuiperClassNames,
  Loader,
  DraftJSEditor,
} from '@opallabs/kuiper'
import { getEditorColors } from '../Helpers/textEditorHelper'
import { getUploaderStyles, getThemeStyles } from '../Helpers/themeHelper'
import ImageSlideAsset from '../ImageSlideAsset'
import Slide from '../Slide'

import './styles.scss'

class TextImageSlide extends Component {
  static propTypes = {
    alignment: oneOf(['right', 'left', 'top', 'bottom']),
    assetReference: object,
    backgroundImageURL: string,
    getSlide: func,
    htmlText: string,
    presentationId: number,
    slideId: number,
    theme: object,
    thumbnail: bool,
    updateSlide: func,
    uploadAsset: func,
    viewOnlyMode: bool,
    withHoverableOverlay: bool,
  }

  static defaultProps = {
    alignment: 'right',
    updateSlide: () => {},
    theme: {},
    thumbnail: false,
    withHoverableOverlay: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      imageAssetLoading: false,
    }
  }

  onChange = (changes) => {
    this.props.updateSlide(
      this.props.presentationId,
      this.props.slideId,
      changes
    )
  }

  uploadInstructions = (file) => {
    const { presentationId, slideId } = this.props

    const updateSlide = ({ data }) => {
      const changes = { canvas_asset_reference_id: data.id }
      this.props.updateSlide(presentationId, slideId, changes)
    }

    this.props.uploadAsset({
      file,
      onUploadSuccess: updateSlide,
    })

    this.setState({ imageAssetLoading: true })
  }

  get customStyles() {
    const themeStyles = getThemeStyles(this.props.theme, [
      'bodyFontColor',
      'bodyFontFamily',
    ])
    const borderColor = getEditorColors(this.props.theme).borderColor
    const hoverColor = getEditorColors(this.props.theme).backgroundColor

    return { ...themeStyles, borderColor, hoverColor }
  }

  get uploaderBackgroundColor() {
    return getUploaderStyles(this.props.theme, ['backgroundColor'])
  }

  get imageContainer() {
    const {
      assetReference,
      presentationId,
      slideId,
      thumbnail,
      updateSlide,
      viewOnlyMode,
      withHoverableOverlay,
    } = this.props

    if (assetReference) {
      return (
        <div className={kuiperClassNames('asset-container')}>
          <ImageSlideAsset
            assetReference={assetReference}
            onDelete={() => this.setState({ imageAssetLoading: false })}
            presentationId={presentationId}
            slideId={slideId}
            updateSlide={updateSlide}
            thumbnail={thumbnail}
            viewOnlyMode={viewOnlyMode}
          />
        </div>
      )
    }

    if (viewOnlyMode && !withHoverableOverlay) return null

    return (
      <AreaUploader
        allowableFiles={['image']}
        customStyles={this.uploaderBackgroundColor}
        disabled={viewOnlyMode}
        uploadInstructions={this.uploadInstructions}
      />
    )
  }

  render() {
    return (
      <div
        className={kuiperClassNames('text-image-slide', this.props.alignment)}
      >
        <Slide
          backgroundImageURL={this.props.backgroundImageURL}
          getSlide={this.props.getSlide}
          presentationId={this.props.presentationId}
          slideId={this.props.slideId}
          theme={this.props.theme}
        >
          <div className={kuiperClassNames('text-container')}>
            <DraftJSEditor
              entityType="slide"
              htmlText={this.props.htmlText}
              saveEditorState={this.onChange}
              saveOnChange={true}
              customStyles={this.customStyles}
              viewOnlyMode={this.props.viewOnlyMode}
              floatingControls={true}
              verticalTextAlignment="center"
              theme="dark-presentation"
            />
          </div>
          <div className={kuiperClassNames('image-container')}>
            {this.imageContainer}
            <Loader
              loaded={
                !this.state.imageAssetLoading ||
                Boolean(this.props.assetReference)
              }
            />
          </div>
        </Slide>
      </div>
    )
  }
}

export default TextImageSlide
